<template>
    <b-nav vertical class="mt-3 ml-4">
        <b-nav-item v-for="(item, index) in menu" :key="index" :class="item.activeCondition ? 'page-navigation nav-active' : 'page-navigation'" :href="item.path">
            <b>{{ item.title | toUpperCase }}</b>
            <b-icon v-if="item.activeCondition" icon="caret-right-fill" shift-v="1" />
        </b-nav-item>
    </b-nav>
</template>

<script>
export default {
    name: 'SidebarNav',
    props: [
		'checkRole',
		'user',
	],
    data() {
        return {
            menu: this.checkRole(this.user, 'ROLE_ADMIN') ? [
                // admin menu navs
                { path: '/home', title: this.$t('text_menu_home'), activeCondition: this.$route.path.startsWith('/home') },
                { path: '/task/new', title: this.$t('text_menu_task_log'), activeCondition: this.$route.path == '/task/new' },
                { path: '/task', title: this.$t('text_menu_task'), activeCondition: this.$route.path.startsWith('/task') && this.$route.path != '/task/new' },
                { path: '/invoice', title: this.$t('text_menu_invoice'), activeCondition: this.$route.path.startsWith('/invoice') },
                { path: '/worker', title: this.$t('text_menu_worker'), activeCondition: this.$route.path.startsWith('/worker') },
                { path: '/customer', title: this.$t('text_menu_customer'), activeCondition: this.$route.path.startsWith('/customer') },
                { path: '/product', title: this.$t('text_menu_products'), activeCondition: this.$route.path.startsWith('/product') },
                { path: '/report', title: this.$t('text_menu_report'), activeCondition: this.$route.path.startsWith('/report') },
            ] : [
                // user menu navs
                { path: '/home', title: this.$t('text_menu_home'), activeCondition: this.$route.path.startsWith('/home') },
                { path: '/task/new', title: this.$t('text_menu_task_log'), activeCondition: this.$route.path == '/task/new' },
                { path: '/task', title: this.$t('text_menu_task'), activeCondition: this.$route.path.startsWith('/task') && this.$route.path != '/task/new' },
                { path: '/customer', title: this.$t('text_menu_customer'), activeCondition: this.$route.path.startsWith('/customer') },
                { path: '/product', title: this.$t('text_menu_products'), activeCondition: this.$route.path.startsWith('/product') },
            ]
        }
    },
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
    }
}
</script>
